import { union } from 'io-ts/Decoder';

import { Id as ClientId } from '../../client/Id';
import { Id as FranchiseId } from '../../franchise/Id';
import { Id as OrganizationId } from '../../organization/Id';
import { Id as PrincipalId } from '../../principal/Id';
import { Id as UserId } from '../../user/Id';

export const ParentId = union(FranchiseId, OrganizationId, PrincipalId, ClientId, UserId);
